
window._ = require('lodash');
// window.jQuery = require('jquery');
//
//
// window.$ = window.jQuery;

import $ from 'jquery';
require('jquery-ui-bundle');
window.jQuery = $;
window.$ = $;


require('angular');
require('angular-route');
require('angular-animate');
require('angular-sanitize');
require('angular-ui-bootstrap');
require('angular-growl-v2');
require('angular-moment');
require('angular-promise-tracker');

require('angular-scroll');
require('angular-ui-slider');
require('ui-select');
require('angular-ui-sortable');
require('moment-timezone');
// require('cmelo-sticky');
require('angular-i18n/angular-locale_fr-fr.js');

require('file-saver');
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js